import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hcpfooter',
  templateUrl: './hcpfooter.component.html',
  styleUrls: ['./hcpfooter.component.scss']
})
export class HcpfooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
